module.exports = __webpack_public_path__ + "img/icb-leo-Adv-e@2x.2ebf6c15.png";